import { render, staticRenderFns } from "./HotelsToApprove.vue?vue&type=template&id=2450e98c&scoped=true&"
import script from "./HotelsToApprove.vue?vue&type=script&lang=js&"
export * from "./HotelsToApprove.vue?vue&type=script&lang=js&"
import style0 from "./HotelsToApprove.vue?vue&type=style&index=0&id=2450e98c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2450e98c",
  null
  
)

export default component.exports